import {LOCAL_STORAGE_KEYS} from "../utils/constants";
import {invokeApi} from "../bl_libs/invokeApi";
import {use_e2ee} from "../utils/utils";

export const getInsiderUserGroupsService = async () => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path: '/dq_insider/get/user_groups',
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    };

    return invokeApi(requestObj, use_e2ee());
}

export const getInsiderPackageService = async (user_group) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path: '/dq_insider/get/package',
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    };

    requestObj['postData'] = {
        user_group
    };

    return invokeApi(requestObj, use_e2ee());
}

export const buildInsiderAssessmentService = async (payload) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path: '/dq_insider/build/assessment',
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    };

    requestObj['postData'] = {
        ...payload
    };

    return invokeApi(requestObj, use_e2ee());
}

export const getInsiderAssessmentsService = async () => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path: '/dq_insider/get/assessments',
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    }

    return invokeApi(requestObj, use_e2ee());
}

export const getInsiderAssessmentDescriptionService = async (user_group, indicators_descriptions, locales) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path: '/dq_insider/get/assessment/description',
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    };

    requestObj['postData'] = {
        user_group,
        indicators_descriptions,
        locales
    };

    return invokeApi(requestObj, use_e2ee());
}

export const getInsiderAssessmentPreviewService = async (dq_module_code) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path: '/dq_insider/get/assessment/preview',
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    };

    requestObj['postData'] = {
        dq_module_code
    };

    return invokeApi(requestObj, use_e2ee());
}